import React, { useState } from "react";
import ApiDatabase from "server";
import UseContext from "hooks/useContext";
import Modalheader from "components/modal/components/header";
import PerimeterModalFooter from "components/modal/dataModal/data/perimeter/PerimeterModalFooter";
import usePerimeterModal from "components/modal/dataModal/data/perimeter/usePerimeterModal";
import { fillText, getCountText } from "pages/profil/perimeters/perimeterText";

// A restored perimeter comes back without any member, and its finished
// missions are restricted to it again: until members are attached, only the
// unrestricted ones see them. Hence the confirmation before the request.
const RestorePerimeterModal = () => {
    const { language, perimeterModalData } = UseContext();
    const { isSaving, setIsSaving, close, succeed, fail } = usePerimeterModal();
    const [{ perimeter, usage }] = useState(() => perimeterModalData || {});
    const finishedMissions = Number(usage?.finishedMissions) || 0;

    const handleConfirm = () => {
        if (isSaving) return;
        setIsSaving(true);
        ApiDatabase.postRestorePerimeter(
            { id: perimeter?.id },
            () =>
                succeed(
                    fillText(language.getValue("perimeters.toast.restored"), {
                        name: perimeter?.name,
                    })
                ),
            (err) => fail(err)
        );
    };

    return (
        <>
            <Modalheader
                hide={close}
                hideShow={true}
                description={getCountText( language, "perimeters.restore.description", finishedMissions )}
            >
                {fillText(language.getValue("perimeters.restore.title"), {
                    name: perimeter?.name,
                })}
            </Modalheader>
            <PerimeterModalFooter
                confirmLabel={language.getValue("perimeters.archived.restore")}
                savingLabel={language.getValue("perimeters.restore.restoring")}
                isSaving={isSaving}
                onCancel={close}
                onConfirm={handleConfirm}
            />
        </>
    );
};

export default RestorePerimeterModal;
